import React from 'react';
import PropTypes from 'prop-types';
import {injectIntl} from 'react-intl';
import utils from "../utils/utils";
import {PDFViewer} from '@react-pdf/renderer';
import Loader from "../components/loader";
import MarketplaceAdminBillPdfDocument from "./marketplaceAdminBillPdfDocument";

const MarketplaceAdminBillPdf = React.memo(({intl, bill}) => {
  if (!intl || !bill || !bill.from && !bill.fromName || !bill.to && !bill.toName) {
    return (
      <Loader show={true}/>
    );
  }

  // this is needed because when downloading the doc, you can't access intl
  const copy = utils.getPdfCopy(intl, bill);

  return (
    <PDFViewer>
      <MarketplaceAdminBillPdfDocument bill={bill} copy={copy}/>
    </PDFViewer>
  );
});

MarketplaceAdminBillPdf.propTypes = {
  bill: PropTypes.object.isRequired,
};

MarketplaceAdminBillPdf.defaultProps = {};

export default injectIntl(MarketplaceAdminBillPdf);